import { useContext } from 'react'
import { AuthContext as JwtContext } from '../contexts/JWTContext'
import { AuthContext as CognitoContext } from '../contexts/CognitoContext'
import { AuthMethod, CognitoContextType, JWTContextType } from '../types/auth'

export const useJwtAuth = () => {
  return useAuth('jwt') as JWTContextType
}

export const useCognitoAuth = () => {
  return useAuth('cognito') as CognitoContextType
}

export const isCognitoContext = (
  context: JWTContextType | CognitoContextType
): context is CognitoContextType => context.method === 'cognito'

const useAuth = (method?: AuthMethod) => {
  const resolvedMethod: AuthMethod =
    method ?? (import.meta.env?.VITE_APP_AUTH_PROVIDER as AuthMethod) ?? 'jwt'

  const cognitoContext = useContext(CognitoContext)
  const jwtContext = useContext(JwtContext)

  const context = resolvedMethod === 'cognito' ? cognitoContext : jwtContext

  if (!context) {
    throw new Error('AuthContext must be placed within AuthProvider')
  }

  return context
}

export default useAuth
